
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetolonavalacabs() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Cabs',
        heading: 'Mauli Cabs: Pune to Lonavala Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Lonavala cabs, ensuring a smooth and scenic journey to the popular hill station of Lonavala. Whether you are visiting for a weekend getaway, a family trip, or to explore the beautiful landscapes, we provide a variety of vehicles including sedans, SUVs, and premium cars to meet your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Lonavala.',

        top: 'Top Places to Visit in Lonavala with Mauli Cabs',

"topPlaces": [
    {
        "title": "Lonavala Lake",
        "description": "Lonavala Lake is a beautiful natural lake surrounded by lush greenery and hills. It's a serene spot for nature lovers and a great place for picnics and photography, especially during the monsoon season."
    },
    {
        "title": "Karla Caves",
        "description": "Karla Caves are ancient rock-cut Buddhist caves dating back to the 2nd century BCE. They are known for their magnificent sculptures and inscriptions and provide a glimpse into India’s rich Buddhist heritage."
    },
    {
        "title": "Bhushi Dam",
        "description": "Bhushi Dam is a popular spot for tourists during the monsoon season. The dam is surrounded by lush greenery and offers an opportunity to enjoy a peaceful day amidst nature. It's a perfect place for a day picnic."
    },
    {
        "title": "Tiger’s Leap",
        "description": "Tiger’s Leap is one of the best viewpoints in Lonavala, offering panoramic views of the valley and the Sahyadri ranges. The cliff's edge resembles a tiger leaping off, which is how it got its name."
    },
    {
        "title": "Rajmachi Fort",
        "description": "Rajmachi Fort is a historic fort located on the Sahyadri mountain range, offering stunning views of the surrounding landscape. It is accessible via a trek and is an ideal spot for adventure enthusiasts."
    },
    {
        "title": "Pawna Lake",
        "description": "Pawna Lake is a serene lake located about 20 km from Lonavala. It is a popular spot for camping, fishing, and picnics, offering a peaceful retreat in the lap of nature."
    },
    {
        "title": "Della Adventure Park",
        "description": "Della Adventure Park is one of the largest adventure parks in India, offering a variety of activities like dirt biking, zorbing, bungee jumping, and more. It's a great place for thrill-seekers and families looking for an adventurous outing."
    },
    {
        "title": "Bushi Dam Waterfall",
        "description": "The Bushi Dam Waterfall is located near Bhushi Dam and is a popular tourist spot, especially during the monsoon. The water cascades over the dam's edge, creating a beautiful and refreshing scene."
    },
    {
        "title": "Lohagad Fort",
        "description": "Lohagad Fort is a historic fort located near Lonavala, known for its impressive architecture and scenic views. The fort is a popular trekking destination and offers a glimpse into Maharashtra’s glorious past."
    },
    {
        "title": "Kondana Caves",
        "description": "Kondana Caves are a group of ancient Buddhist caves located near Lonavala. These caves are less crowded compared to other caves in the region and provide a peaceful environment for history and nature lovers."
    }
],

"services": [
    {
      "name": "Pune to Lonavala Cab Booking",
      "description": "Book a comfortable and reliable cab for your journey from Pune to Lonavala. Our service ensures a smooth and hassle-free trip."
    },
    {
      "name": "Taxi from Pune to Lonavala Karla Caves",
      "description": "Take a taxi from Pune to Lonavala and visit the famous Karla Caves. Enjoy a comfortable ride with our reliable taxi services."
    },
    {
      "name": "Pune to Lonavala Car Hire",
      "description": "Rent a car for your trip from Pune to Lonavala. Choose from a wide selection of vehicles for a flexible and comfortable journey."
    },
    {
      "name": "Pune to Lonavala Cab Rental",
      "description": "Rent a cab for your journey from Pune to Lonavala. We offer a variety of vehicles to suit your needs for a relaxing travel experience."
    },
    {
      "name": "Pune to Lonavala Cab Price",
      "description": "Check the cab prices for your trip from Pune to Lonavala. Get the best rates for a smooth, comfortable, and affordable ride."
    },
    {
      "name": "Pune to Lonavala Taxi Fare",
      "description": "Get accurate taxi fare estimates for your Pune to Lonavala trip. Our pricing is transparent with no hidden charges."
    },
    {
      "name": "Book Cab from Pune to Lonavala",
      "description": "Book a reliable cab for your journey from Pune to Lonavala. Our easy-to-use booking platform ensures a smooth and timely ride."
    },
    {
      "name": "Pune to Lonavala Travel by Taxi to Kune Falls",
      "description": "Visit Kune Falls in Lonavala with our taxi service. We offer a comfortable and convenient ride to this beautiful waterfall."
    },
    {
      "name": "Pune to Lonavala Cabs",
      "description": "Book a cab from Pune to Lonavala for a quick, comfortable, and enjoyable journey. We offer multiple vehicle options to suit your needs."
    },
    {
      "name": "Pune to Lonavala Cab Tour Package",
      "description": "Explore Lonavala with a complete cab tour package from Pune. This all-inclusive package covers transportation and sightseeing."
    },
    {
      "name": "Pune to Lonavala Taxi Fare",
      "description": "Find the most competitive taxi fares for your Pune to Lonavala journey. We ensure you get the best price for a comfortable ride."
    },
    {
      "name": "Pune Airport to Lonavala Taxi Fare",
      "description": "Book a taxi from Pune Airport to Lonavala. Check taxi fare estimates for a convenient airport transfer."
    },
    {
      "name": "Book Cab From Pune to Lonavala",
      "description": "Book a cab online from Pune to Lonavala. Our booking platform ensures fast, reliable, and affordable rides."
    },
    {
      "name": "Cab Fare from Pune to Lonavala",
      "description": "Check the cab fare for your journey from Pune to Lonavala. We offer competitive pricing with transparent fare structures."
    },
    {
      "name": "Cab Service From Pune to Lonavala",
      "description": "Get reliable cab services for your trip from Pune to Lonavala. Choose from a range of vehicles based on your preferences and budget."
    },
    {
      "name": "Hinjewadi to Lonavala Taxi Fare",
      "description": "Find the taxi fare from Hinjewadi to Lonavala. Our pricing options are affordable and based on distance."
    },
    {
      "name": "Lonavala to Bhimashankar Taxi",
      "description": "Book a taxi from Lonavala to Bhimashankar. Enjoy a safe and comfortable ride to this sacred site."
    },
    {
      "name": "Lonavala to Matheran Taxi Fare",
      "description": "Check taxi fares for your trip from Lonavala to Matheran. We offer affordable and reliable taxi services for this journey."
    },
    {
      "name": "Lonavala to Pune Cab Service",
      "description": "Book a cab for your journey from Lonavala to Pune. We provide a comfortable and timely ride back to Pune."
    },
    {
      "name": "Lonavala to Pune Taxi",
      "description": "Book a taxi from Lonavala to Pune. Our service ensures a convenient and comfortable ride with competitive pricing."
    },
    {
      "name": "Pune to Lonavala Cab Charges",
      "description": "Check the cab charges for your journey from Pune to Lonavala. We offer competitive and transparent pricing options."
    },
    {
      "name": "Pune to Lonavala Cab Cost",
      "description": "Estimate the cost of your Pune to Lonavala cab journey. Our pricing system offers affordable rates with no hidden charges."
    },
    {
      "name": "Pune to Lonavala Taxi Service",
      "description": "Book a taxi from Pune to Lonavala for a safe, comfortable, and timely ride. We offer affordable and reliable services."
    },
    {
      "name": "Pune to Lonavala Cab Service",
      "description": "Enjoy a premium cab service for your journey from Pune to Lonavala. Choose from a variety of vehicle options for comfort and convenience."
    },
    {
      "name": "Pune Airport to Lonavala Taxi Fare",
      "description": "Book a taxi from Pune Airport to Lonavala with ease. Our taxi service ensures timely pick-up and drop-off at competitive rates."
    },
    {
      "name": "Pune to Lonavala Cab Package",
      "description": "Book a complete Pune to Lonavala cab package. Our package includes transportation and sightseeing for a complete travel experience."
    }
  ],
  "tableData": [
    ["Pune to Lonavala Cab Booking", "Taxi from Pune to Lonavala Karla Caves"],
    ["Pune to Lonavala Car Hire", "Pune to Lonavala Cab Rental"],
    ["Pune to Lonavala Cab Price", "Pune to Lonavala Taxi Fare"],
    ["Book Cab from Pune to Lonavala", "Pune to Lonavala Travel by Taxi to Kune Falls"],
    ["Pune to Lonavala Cabs", "Pune to Lonavala Cab Tour Package"],
    ["Pune to Lonavala Taxi Fare", "Pune Airport to Lonavala Taxi Fare"],
    ["Book Cab From Pune to Lonavala", "Cab Fare from Pune to Lonavala"],
    ["Cab Service From Pune to Lonavala", "Hinjewadi to Lonavala Taxi Fare"],
    ["Lonavala to Bhimashankar Taxi", "Lonavala to Matheran Taxi Fare"],
    ["Lonavala to Pune Cab Service", "Lonavala to Pune Taxi"],
    ["Pune to Lonavala Cab Charges", "Pune to Lonavala Cab Cost"],
    ["Pune to Lonavala Taxi Service", "Pune to Lonavala Cab Service"],
    ["Pune Airport to Lonavala Taxi Fare", "Pune to Lonavala Cab Package"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs provides reliable and timely service for your Pune to Lonavala trip. Whether you're going for a weekend getaway, a business trip, or a leisure visit, our drivers ensure punctual pickups and drop-offs, ensuring a smooth and stress-free ride."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Lonavala journey, we offer a range of comfortable and spacious vehicles. Whether you prefer a sedan, SUV, or premium car, all our vehicles are air-conditioned and well-maintained, providing you with a relaxing and enjoyable ride through the scenic route."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the Pune to Lonavala route. They ensure a smooth and safe journey, knowing the best roads and avoiding traffic, so you can enjoy the beautiful landscapes along the way."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune to Lonavala cab booking. With no hidden charges, we provide clear and upfront pricing, ensuring that you get the best value for your money."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure you have a secure and comfortable journey to Lonavala."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Lonavala trip. Whether you need a ride early in the morning or a late-night return, our customer service team is always available to assist you with your booking, ensuring convenience at any hour."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Lonavala cab with Mauli Cabs is quick and hassle-free. You can book your ride online via our website or mobile app, or contact our customer service team for personalized assistance and a seamless booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Lonavala journey. Whether you're planning a relaxing weekend getaway or a sightseeing tour, we can tailor your trip to suit your needs and ensure a memorable experience."
    }
]
















    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Lonavala with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Lonavala with Mauli Cabs is easy! You can book through our website or mobile app by entering your pickup location (Pune) and destination (Lonavala), selecting your vehicle, and confirming the booking. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Lonavala trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for the Pune to Lonavala route, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Whether you are traveling solo, with family, or in a group, we have the right vehicle for your needs.',
        },
        {
            question: 'Is the fare for the Pune to Lonavala trip fixed?',
            answer: 'Yes, the fare for the Pune to Lonavala trip is fixed and transparent. The fare includes tolls, taxes, and driver charges, with no hidden costs. You’ll be informed of the total fare upfront when you confirm your booking.',
        },
        {
            question: 'Can I book a round trip from Pune to Lonavala?',
            answer: 'Yes, you can easily book a round trip from Pune to Lonavala. Just provide your return details during the booking process, and we’ll ensure you have a smooth journey both ways.',
        },
        {
            question: 'How long does the journey from Pune to Lonavala take?',
            answer: 'The journey from Pune to Lonavala typically takes around 1.5 to 2 hours, depending on traffic and road conditions. Mauli Cabs drivers are experienced and will ensure a comfortable and timely ride.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Lonavala route?',
            answer: 'Yes, all Mauli Cabs drivers are professional, experienced, and familiar with the best routes between Pune and Lonavala. They prioritize your safety and comfort throughout the journey.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Lonavala?',
            answer: 'Yes, you can make stops along the way for breaks, sightseeing, or meals. Our drivers are happy to accommodate your requests and ensure that your journey is comfortable and enjoyable.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Lonavala trip?',
            answer: 'Yes, all our cabs for the Pune to Lonavala trip are fully air-conditioned and regularly maintained for cleanliness and comfort. We ensure a smooth and pleasant ride every time.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Lonavala trip?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Lonavala trip. We offer a flexible cancellation policy through our website or app, and our customer support team is available to assist you at any time.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Lonavala trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicle options, professional drivers, and a commitment to punctuality. Whether you’re visiting Lonavala for a quick getaway or a day trip, we ensure a comfortable and hassle-free experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vikram Patel",
            position: "Business Executive",
            text: "I used Mauli Cabs for my trip from Pune to Lonavala, and it was a fantastic experience. The driver was punctual, the vehicle was clean and comfortable, and the ride was smooth. I will definitely book with them again for my future trips!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Sharma",
            position: "Vacation Traveler",
            text: "My trip to Lonavala from Pune was made incredibly smooth and comfortable by Mauli Cabs. The driver was friendly, knowledgeable, and ensured I had a pleasant experience. I highly recommend Mauli Cabs for anyone traveling to Lonavala!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Lonavala Cabs Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and reliable taxi services from Pune to Lonavala, including one-way, round-trip, and sightseeing options. Visit top attractions like Karla Caves, Kune Falls, and enjoy a comfortable ride with 24x7 booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
    
    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Lonavala Cabs | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Lonavala cab with Mauli Cabs. Choose from affordable taxi services for one-way or round-trip travel. Explore places like Karla Caves, Kune Falls, and enjoy a comfortable ride to Lonavala with reliable taxi service."
        />
        <meta
          name="keywords"
          content="Pune to Lonavala Cab Booking, Taxi from Pune to Lonavala Karla Caves, Pune to Lonavala Car Hire, Pune to Lonavala Cab Rental, Pune to Lonavala Cab Price, Pune to Lonavala Taxi Fare, Book Cab from Pune to Lonavala, Pune to Lonavala Travel by Taxi to Kune Falls, Pune to Lonavala Cabs, Pune to Lonavala Cab Tour Package, Pune to Lonavala Taxi Fare, Pune Airport to Lonavala Taxi Fare, Book Cab From Pune to Lonavala, Cab Fare from Pune to Lonavala, Cab Service From Pune to Lonavala, Hinjewadi to Lonavala Taxi Fare, Lonavala to Bhimashankar Taxi, Lonavala to Matheran Taxi Fare, Lonavala to Pune Cab Service, Lonavala to Pune Taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavalacabs;